module.exports = __webpack_public_path__ + "img/icon_data_empty_black.fcab8232.png";